export type NotificationChannel = 'push' | 'whatsapp' | 'email';

export type NotificationCategory = 
  | 'order-confirmed'
  | 'out-for-delivery'
  | 'eta-update'
  | 'next-stop'
  | 'delivered'
  | 'issue-response'
  | 'backorder-update'
  | 'substitution-offered'
  | 'driver-rating';

export interface INotificationChannelConfig {
  enabled: boolean;
}

export interface IWhatsAppChannelConfig extends INotificationChannelConfig {
  number?: string;
  isOptedIn?: boolean;
  profileName?: string;
}

export interface INotificationPreferences {
  channels: {
    push: INotificationChannelConfig;
    email: INotificationChannelConfig;
    whatsapp: IWhatsAppChannelConfig;
  };
  categories: Record<NotificationCategory, boolean>;
  pauseAll?: boolean;
  nightMode?: boolean;
}

export const defaultNotificationPreferences: INotificationPreferences = {
  channels: {
    push: { enabled: true },
    email: { enabled: true },
    whatsapp: { enabled: true },
  },
  categories: {
    'order-confirmed': true,
    'out-for-delivery': true,
    'eta-update': true,
    'next-stop': true,
    'delivered': true,
    'issue-response': true,
    'backorder-update': true,
    'substitution-offered': false,
    'driver-rating': true,
  },
  pauseAll: false,
  nightMode: true,
};
